// extracted by mini-css-extract-plugin
export default {"BottomNavBar":"BottomNavBar_BottomNavBar__IlXk2","Wrapper":"BottomNavBar_Wrapper__3Jck8"};